import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { MessagesStatusUpdate } from '@/types/events/messages-status-update';

export default function messagesStatusUpdate(data: MessagesStatusUpdate): void {
  const conversationsStore = useConversationsStore();
  conversationsStore.updateCachedMessageStatus(data);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateMessageStatus(data);
  }
}
